module.exports = __webpack_public_path__ + "img/selected6-min.b7bf86f7.png";